import { createTheme } from '@mui/material';

export const purpleTheme = () =>
  createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            '--color-brand-twilight-500': '#1F1A5E',
            '--color-text-error': '#AE0A00',
            '--color-text-secondary': '#6F6990',
            '--color-brand-midnight': '#181831',
            width: '100%',
            '& label': {
              color: 'var(--color-text-secondary)',
              'font-size': '0.875rem',
              fontFamily: '"Graphik", arial, sans-serif',

            },
            '& label.Mui-focused': {
              color: 'var(--color-brand-midnight)',
            },
            '& label.Mui-error:not(.Mui-focused)': {
              color: 'var(--color-text-secondary)',
            },
          },
        },
      },
      MuiFilledInput: {
        styleOverrides: {
          root: {
            fontWeight: 500,
            fontFamily: '"Graphik", arial, sans-serif',
            fontSize: '0.875rem',
            letterSpacing: '0',
            borderRadius: '0rem',
            backgroundColor: '#F5F4F4',
            color: 'var(--color-brand-midnight)',
            paddingRight: '0rem',
            '--color-text-error': '#AE0A00',
            '&.Mui-focused': {
              backgroundColor: '#F5F4F4',
            },
            '&:hover': {
              backgroundColor: '#F5F4F4',
            },
            '&.Mui-focused:has(#password)': {
              border: '1px solid var(--color-brand-midnight)',
            },
            '&.Mui-focused:not(.Mui-disabled, .Mui-error) > input:not(#password)': {
              border: '1px solid var(--color-brand-midnight)',
              borderRadius: '0rem',
            },
            '&.Mui-focused:not(.Mui-disabled, .Mui-error) > input#promo-code, &.Mui-focused:not(.Mui-disabled, .Mui-error) > input#txt-zip-code': {
              border: '1px solid var(--color-brand-midnight)',
              'border-radius': '0.5rem 0 0 0.5rem',
            },
            '&.Mui-focused > .MuiInputAdornment-positionEnd > button:not(.MuiIconButton-root)': {
              border: '1px solid var(--color-brand-midnight)',
              borderLeft: '0',
            },
            '&.Mui-error > input:not(#password)': {
              borderRadius: '0rem',
              border: '1px solid var(--color-text-error)',
              backgroundColor: '#F5F4F4',
            },
            '&.Mui-error:has(#password)': {
              border: '1px solid var(--color-text-error)',
            },
            '&.Mui-error > .MuiInputAdornment-positionEnd > button:not(.MuiIconButton-root)': {
              border: '1px solid var(--color-brand-midnight)',
              borderLeft: '0',
            },
            '&.Mui-error:hover': {
              borderBottom: 'none',
            },
            '&.Mui-error:after, &.Mui-error:before': {
              borderBottom: 'none',
            },
            '&.Mui-focused:not(.Mui-disabled, .Mui-error):after, &.Mui-focused:not(.Mui-disabled, .Mui-error):before': {
              borderBottom: 'none',
            },
            '&:hover:not(.Mui-disabled, .Mui-error):before': {
              borderBottom: 'none',
            },
            '&:before, &:not(.Mui-disabled, .Mui-error):after': {
              borderBottom: 'none',
            },
          },
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            '--color-text-error': '#AE0A00',
            color: 'var(--color-text-error)',
            margin: '.5rem 0 0',
          },
        },
      },
      MuiNativeSelect: {
        styleOverrides: {
          root: {
            '--color-text-secondary': '#6F6990',
          }
        }
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            '--color-brand-midnight': '#1F1A5E',
            '--color-text-error': '#AE0A00',
            '--color-text-secondary': '#6F6990',
            borderRadius: '0rem',
            backgroundColor: '#F5F4F4',
            color: 'var(--color-brand-midnight)',
            '&.Mui-active': {
              color: 'var(--color-brand-midnight)',
            },
            '&.Mui-focused': {
              backgroundColor: '#F5F4F4',
            },
            '&:hover': {
              backgroundColor: '#F5F4F4',
            },
            '&.Mui-focused:not(.Mui-disabled, .Mui-error)': {
              border: '1px solid var(--color-brand-midnight)',
            },
            '&.Mui-error': {
              border: '1px solid var(--color-text-error)',
              backgroundColor: '#F5F4F4',
            },
            '&.Mui-error:hover': {
              borderBottom: '1px solid var(--color-text-error)',
            },
            '&.Mui-error:after, &.Mui-error:before': {
              borderBottom: 'none',
            },
            '&.Mui-focused:not(.Mui-disabled, .Mui-error):after, &.Mui-focused:not(.Mui-disabled, .Mui-error):before':
              {
                borderBottom: 'none',
              },
            '&:hover:not(.Mui-disabled, .Mui-error):before': {
              borderBottom: 'none',
            },
            '&:before, &:not(.Mui-disabled, .Mui-error):after': {
              borderBottom: 'none',
            },
          },
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            '--color-text-secondary': '#6F6990',
            color: 'var(--color-text-secondary)',
            'font-size': '0.875rem',
            fontFamily: '"Graphik", arial, sans-serif',
            '&.Mui-focused': {
              color: 'var(--color-brand-midnight)',
            },
            '&.Mui-error:not(.Mui-focused)': {
              color: 'var(--color-text-secondary)',
            },
          },
        },
      },
      MuiInputAdornment: {
        styleOverrides: {
          root: {
            margin: '0',

          }
        }
      }
    },
  });
